import React from 'react';
import { CreateProps } from '../../types/utils/CreateProps';

import BaseInput, { BaseInputPropsWithoutChildren } from '../Input/BaseInput';

import style from './SearchInput.module.scss';

export type SearchInputProps = CreateProps<
  {
    /** The value that is set to the input */
    value?: string;
    /** OnClick handler for the icon */
    onIconClick?: () => void;
    /** Placeholder is visible when the input is empty */
    placeholder?: string;
    /** Sets the input to disabled state */
    disabled?: boolean;
    /** Custom id */
    id?: string;
    /** Type */
    type?: 'text' | 'search' | 'email' | 'password' | 'tel' | 'url' | undefined;
  },
  BaseInputPropsWithoutChildren,
  | 'iconName'
  | 'type'
  | 'confirmed'
  | 'required'
  | 'errorText'
  | 'helperText'
  | 'label'
>;

const SearchInput: React.FunctionComponent<SearchInputProps> = ({
  className,
  showCustomLabel = true,
  value,
  type = 'text',
  ...props
}) => (
  <BaseInput
    {...props}
    label={undefined}
    showCustomLabel={showCustomLabel}
    iconName="search"
    iconColor={'gray500'}
    type={type}
    confirmed={false}
    required={false}
    errorText={undefined}
    className={[style.searchInput, className]}
    value={value}
  />
);

export default SearchInput;
